import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useCaViewQuery } from '../../store/auth/authService'

import { Button } from '@material-tailwind/react';
import ArrowAccordionIcon from '../../images/icons/ArrowAccordionIcon';
import RequisitesContract from './blocks/RequisitesContract';
import InfoContract from './blocks/InfoContract';
import ContactsContract from './blocks/ContactsContract';
import PaymentPlanContract from './blocks/PaymentPlanContract';
import DocumentsContract from './blocks/DocumentsContract';
import PointsContract from './blocks/PointsContract';
import { DateSelectType } from './ContractPage.types'
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { setServiceId } from '../../store/service/contractSlice';
import ButtonMoveTop, { handleScrollToId } from '../../components/buttonMoveTop/ButtonMoveTop';
import { hasRoleAccess, RolesType } from '../../utils/roles';

const ContractPageBlocks = ({ roles, setDateSelect }: {
    roles: RolesType | undefined
    setDateSelect: (value: DateSelectType) => void
}
) => {

    const { param_contract_id } = useParams()

    const { data, error, isLoading, isFetching } = useCaViewQuery({
        contract_id: Number(param_contract_id)
    })

    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        if (data?.service_id) dispatch(setServiceId(Number(data.service_id)))
    }, [data]);

    useEffect(() => {
        if (data?.dateSelect) setDateSelect(data.dateSelect)
    }, [data]);


    const ButtonMoveReq = () => (
        <Button
            color='white'
            className="flex items-center justify-center w-[72px] h-[40px] my-[24px]
            ease-in-out duration-200  animate-bounce	
            "
            onClick={() => {
                handleScrollToId('req')
            }}
        >
            <span className=' rotate-180'>
                <ArrowAccordionIcon />
            </span>
        </Button>
    )
    return (
        <>
            <div className='mt-[96px] lap:mt-0'>
                <div className='hidden lap:flex flex justify-center mt-[24px] mb-[120px]'>
                    <ButtonMoveReq />
                </div>
                <ButtonMoveTop />
                {
                    (
                        hasRoleAccess('contract.requsite', roles) ||
                        hasRoleAccess('contract.info', roles) ||
                        hasRoleAccess('contract.contact', roles)
                    ) ?
                        <div id='req' className='mb-[96px] lap:mb-[128px] lap:px-[48px] lap:py-[96px] lap:bg-white lap:rounded-[40px] lap:border-2 lap:border-gray-100'>
                            {hasRoleAccess('contract.requsite', roles) && <RequisitesContract data={data?.requisites} isFetching={isFetching} />}
                            {hasRoleAccess('contract.info', roles) && <InfoContract data={data?.info} isFetching={isFetching} />}
                            {hasRoleAccess('contract.contact', roles) && data?.contacts && <ContactsContract data={data.contacts} />}
                        </div>
                        :
                        <></>
                }

                {hasRoleAccess('contract.payment', roles) && data?.pay_plan && <PaymentPlanContract data={data.pay_plan} />}
                {hasRoleAccess('contract.files', roles) && data?.files && <DocumentsContract data={data.files} />}
                {hasRoleAccess('contract.points', roles) && data?.tku && <PointsContract data={data.tku} />}
            </div >
        </>
    )
}

export default ContractPageBlocks
